export default __webpack_public_path__ + "static/media/timer.91ba5dbf.svg";